import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export type CompetitionDivisionListQueryParams = Parameters<typeof SSF.api.competitionDivisionsList>[0];

export const keys = createQueryKeySet<CompetitionDivisionListQueryParams>('competition-divisions');

export function useCompetitionDivisionListQuery(params?: CompetitionDivisionListQueryParams, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.competitionDivisionsList(params);
      return data;
    },
    queryKey: keys.list(params),
    enabled,
  });
}

export function useCompetitionDivisionQuery(id: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.competitionDivisionsRetrieve(id);
      return data;
    },
    queryKey: keys.detail(id),
  });
}
